import { StyleSheet, View, Text } from '@react-pdf/renderer';
import { LogoPDF } from './LogoPDF';

const styles = StyleSheet.create({
	divider: {
		display: 'flex',
		flexDirection: 'row',
		width: '100%',
		height: 2,
		backgroundColor: 'white',
	},

	content: {
		display: 'flex',
		justifyContent: 'space-between',
		flexDirection: 'row',
		alignItems: 'center',
		color: 'white',
		padding: '10 50 30',
		fontSize: 8,
	},
});

export const FooterPDF = () => {
	return (
		<View>
			<View style={styles.divider} />;
			<View style={styles.content}>
				<Text>©{new Date().getFullYear()} TheDenominator, Inc.</Text>

				<LogoPDF />
			</View>
		</View>
	);
};
